// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"157":"52993b52","538":"recorder","561":"90206ced","983":"profiler"}[chunkId] || chunkId) + "." + {"157":"e21a8412d23491f4","277":"b0ef728d9000e1fb","538":"f36c0fc89a0f4f43","561":"7af395af1a81a317","624":"bceba415011e2ffc","769":"6feba3f4d7155f59","983":"54632559c8fbc5a0"}[chunkId] + ".js";
};